import { render, staticRenderFns } from "./UpdatePwd.vue?vue&type=template&id=1a85457e&scoped=true&"
import script from "./UpdatePwd.vue?vue&type=script&lang=js&"
export * from "./UpdatePwd.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePwd.vue?vue&type=style&index=0&id=1a85457e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a85457e",
  null
  
)

export default component.exports